import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useRef } from "react";

import { t } from "@/i18n-js/instance";

import { ACCEPTED_FILE_TYPES } from "./constants";

interface FileAttachmentButtonProps {
  disabled?: boolean;
  onAddFiles: (files: File[]) => void;
}

export const FileAttachmentButton = ({
  disabled = false,
  onAddFiles,
}: FileAttachmentButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={ACCEPTED_FILE_TYPES}
        className="hidden"
        onChange={e => {
          if (e.target.files?.length) onAddFiles(Array.from(e.target.files));
          e.target.value = "";
        }}
      />
      <Tooltip
        content={t("circle_ai_home.composer_file_attachment_button_tooltip")}
      >
        <IconButton
          icon="paperclip"
          variant="ghost"
          size="sm"
          aria-label={t("circle_ai_home.attachments.attach_file")}
          disabled={disabled}
          onClick={() => fileInputRef.current?.click()}
        />
      </Tooltip>
    </>
  );
};
